import React, { useEffect, useState, useContext } from 'react'
import { Container, Row, Col, Image } from 'react-bootstrap'
import styled from 'styled-components'
import { useQueryParams } from 'raviger'
import {
  Title,
  Link,
  ProgramDetailLoader,
  Permission,
  ProgramEditModal,
  ProgramDetail,
  DataSteward,
  ScholarshipSources,
} from 'components'
import snappIcon from 'images/snapp-icon.png'
import { useProgram } from 'hooks/useProgram'
import { device } from 'utils/device'
import { I18nContext } from 'i18n'
import { useOrganization } from 'hooks/useOrganization'

const ProgramDetails = ({ id }) => {
  const { translate } = useContext(I18nContext)
  const { dataDetail, setProgramId, loadingDetail } = useProgram()
  const [showEdit, setShowEdit] = useState(false)
  const [queryParams] = useQueryParams()
  const { fromSearch, isMember } = queryParams
  const goBackLink = fromSearch ? '/search/advanced' : '/programs'
  const [isDataReady, setIsDataReady] = useState(false)

  const { dataDetail: memberDetial, setName, errorDetail } = useOrganization()

  const handleEdit = (e) => {
    e.preventDefault()
    setShowEdit(true)
  }

  const handleHide = () => {
    setProgramId(0)
    setShowEdit(false)
  }

  useEffect(() => {
    if (!showEdit) setProgramId(id)
  }, [showEdit])

  useEffect(() => {
    if (dataDetail) {
      console.log('dataDetail', dataDetail)
      setName(dataDetail.organization.name)
    }
  }, [dataDetail])

  useEffect(() => {
    if (errorDetail || dataDetail) setIsDataReady(true)
  }, [errorDetail, dataDetail])

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }, [])

  const renderData = ({ applicationType, organization, json }) => {
    const icon = organization?.logoURL || snappIcon

    return (
      <>
        <Row>
          <Col>
            <Title>Program Detail</Title>
          </Col>
        </Row>
        <DataRow>
          <Col md="2">
            <ProgramImage src={icon} alt="" fluid />
          </Col>
          <DetailsData>
            <ProgramDetail
              program={{
                ...json,
                applicationType,
                programOrganization: {
                  organizationName: organization?.name,
                },
              }}
              isMember={isMember === 'true'}
            />
            <Footer>
              <div>
                <Link href={goBackLink}>
                  {fromSearch
                    ? translate('program_back_results')
                    : translate('program_back_programs')}
                </Link>
              </div>
              {!fromSearch && (
                <Permission permission={['canEditScholarships']}>
                  <DataSteward>
                    You are data steward for {organization?.name}, which offers
                    this program, so you can{' '}
                    <a href="/data-center" onClick={handleEdit}>
                      edit this information.
                    </a>
                  </DataSteward>
                </Permission>
              )}
            </Footer>
          </DetailsData>
        </DataRow>
        <ScholarshipSources
          divider
          showLastImportedYMFileDate={false}
          showPublicTaxRecord={false}
        />
      </>
    )
  }

  return (
    <DetailsContainer>
      {!isDataReady ? <ProgramDetailLoader /> : renderData(dataDetail)}
      {isDataReady && (
        <ProgramEditModal show={showEdit} onHide={handleHide} id={id} />
      )}
    </DetailsContainer>
  )
}

const ProgramImage = styled(Image)`
  margin-bottom: 1rem;
`

const DetailsData = styled(Col)`
  margin: 0 2rem;
  max-width: 65%;

  @media ${device.laptop} {
    max-width: 100%;
  }
`

const DetailsContainer = styled(Container)`
  margin: 2rem auto;
  color: #3f4040;
  font-size: 1rem;
  font-weight: 300;

  max-width: 80%;

  @media ${device.tablet} {
    max-width: 95%;
  }
`

const Footer = styled.div`
  margin-top: 2rem;

  a {
    font-size: 1rem;
    color: ${(props) => props.theme.link.color};
  }
`

const DataRow = styled(Row)`
  margin-top: 2rem;
`

export default ProgramDetails
